import { render } from "./ProductSlider.vue?vue&type=template&id=702eda2c"
import script from "./ProductSlider.vue?vue&type=script&lang=js"
export * from "./ProductSlider.vue?vue&type=script&lang=js"

import "./ProductSlider.vue?vue&type=style&index=0&id=702eda2c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__